
import productResult from './data/getProductResult'
import providerResult from './data/providerResult'
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))
let shouldReject = false

export default {
  getProduct (productId, providerId) {
    console.log('** getProduct mock **', productId, providerId)
    return new Promise((resolve, reject) => {
      delay(1000).then(() => {
        if (shouldReject) {
          console.error('rejected', reject)
        } else {
          return resolve(productResult)
        }
      })
    })
  },
  getProviders () {
    console.log('** getProviders mock **')
    return new Promise((resolve, reject) => {
      delay(1000).then(() => {
        if (shouldReject) {
          console.error('rejected', reject)
        } else {
          return resolve(providerResult)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/mock/productMockApi.js